import { useRef } from 'react';
import { useSyncExternalStore } from 'use-sync-external-store/shim';
export function useDataFromContainer(container, depsFn) {
    var _a;
    const depsFnRef = useRef(depsFn);
    depsFnRef.current = depsFn;
    const depsRef = useRef(((_a = depsFnRef.current) === null || _a === void 0 ? void 0 : _a.call(depsFnRef, container.data)) || []);
    return useSyncExternalStore(onStoreChange => {
        function subscribe() {
            if (!depsFnRef.current) {
                onStoreChange();
            }
            else {
                const oldDeps = depsRef.current;
                const newDeps = depsFnRef.current(container.data);
                if (compare(oldDeps, newDeps)) {
                    onStoreChange();
                }
                depsRef.current = newDeps;
            }
        }
        container.subscribers.add(subscribe);
        return () => {
            container.subscribers.delete(subscribe);
        };
    }, () => container.data);
}
function compare(oldDeps, newDeps) {
    if (oldDeps.length !== newDeps.length) {
        return true;
    }
    for (const index in newDeps) {
        if (oldDeps[index] !== newDeps[index]) {
            return true;
        }
    }
    return false;
}
